import { useContext, useEffect, useState } from "react";
import { Get, handleError } from "../../../utils/fetch.util";
import { UserContext } from "../../../contexts/user.context";
import LoadingData from "../../loadingData/loadingData.component";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import NoData from "../../noData/noData.component";
import { IoClose } from "react-icons/io5";
import { BiShow } from "react-icons/bi";
import ViewJobRoleLinkedModal from "../ViewJobRoleLinkedModal/ViewJobRoleLinkedModal.component";

type PropsTypes = {
  isOpen: boolean;
  close: () => void;
  sectorId: number;
  siteId: number;
};

export const ViewJobRolesModal = ({
  isOpen,
  close,
  sectorId,
  siteId,
}: PropsTypes) => {
  const { getValidToken } = useContext(UserContext);
  const { t } = useTranslation();
  const [site, setSite] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [openJobRoleLinked, setOpenJobRoleLinked] = useState<boolean>(false);
  const [jobRoleLinked, setJobRoleLinked] = useState<any[]>([]);
  const [typeData, setTypeData] = useState<string>("");

  const getJobRoleLinkedUsersOrStaff = async (
    type: string,
    jobRoleId: number,
  ) => {
    setIsLoading(true);
    setTypeData(type);
    try {
      const res = await Get(
        `job-roles/get-job-role-linked-users-or-staff?job_role_id=${jobRoleId}&site_id=${siteId}&type=${type}`,
        getValidToken(),
      );

      setJobRoleLinked(res.data);
      close();
      setOpenJobRoleLinked(true);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const getSite = async () => {
      setIsLoading(true);
      const res = await Get(
        `sites/get-sector-site?asdc_client_sector_id=${sectorId}&asdc_client_site_id=${siteId}`,
        getValidToken(),
      );
      if (res.error || !res.data) {
        handleError(res);
        setIsLoading(false);
        return;
      }
      setIsLoading(false);
      setSite(res.data);
    };
    isOpen && siteId && siteId > 0 && getSite();
  }, [isOpen]);
  return (
    <>
      {!isLoading && (
        <div
          className={`flex flex-col gap-3 fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white w-1/2 max-h-[90vh] p-6 py-12 !z-[999999] overflow-y-auto duration-300 ${
            isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex justify-between items-center">
            <h2 className="text-3xl mb-6 text-text">{site?.site_name}</h2>
            <button onClick={close} className="text-5xl mb-6">
              <IoClose />
            </button>
          </div>
          {site?.job_roles?.length === 0 && (
            <NoData message={t("no_Job_Roles")} />
          )}
          {site?.job_roles?.length > 0 && (
            <div className="w-full overflow-x-auto">
              <table className="w-full border-collapse mt-5">
                <thead>
                  <tr className="border-collapse border-2">
                    <th
                      className={`border-collapse border-2 p-3 min-w-[50px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("role_name")}
                    </th>
                    <th
                      className={`border-collapse border-2 p-3 min-w-[200px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("users_count")}
                    </th>
                    <th
                      className={`border-collapse border-2 p-3 min-w-[200px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("staff_count")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="h-6">
                    <td></td>
                  </tr>
                  {site?.job_roles?.map((role: any, index: number) => (
                    <tr key={index} className="border-collapse border-2">
                      <td
                        className={`border-collapse border-2 p-3 min-w-[50px] ${
                          i18next.language === "ar" ? "text-right" : "text-left"
                        }`}
                      >
                        {role.name}
                      </td>
                      <td
                        className={`border-collapse border-2 p-3 min-w-[200px] ${
                          i18next.language === "ar" ? "text-right" : "text-left"
                        }`}
                      >
                        <div className="flex items-center justify-between">
                          <span>{role._count.asdc_client_user}</span>
                          <button
                            onClick={() => {
                              getJobRoleLinkedUsersOrStaff("user", role.id);
                            }}
                          >
                            <BiShow size={23} />
                          </button>
                        </div>
                      </td>
                      <td
                        className={`border-collapse border-2 p-3 min-w-[200px] ${
                          i18next.language === "ar" ? "text-right" : "text-left"
                        }`}
                      >
                        <div className="flex items-center justify-between">
                          <span>{role._count.asdc_client_staff}</span>
                          <button
                            onClick={() =>
                              getJobRoleLinkedUsersOrStaff("staff", role.id)
                            }
                          >
                            <BiShow size={23} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
      {isLoading && <LoadingData />}
      <div
        className={`bg-black ${
          isOpen ? "opacity-60" : "opacity-0 pointer-events-none"
        } fixed inset-0 z-[99999] flex items-center justify-center transition-all duration-500`}
        onClick={close}
      ></div>

      <ViewJobRoleLinkedModal
        isOpen={openJobRoleLinked}
        close={() => setOpenJobRoleLinked(false)}
        jobRoleLinked={jobRoleLinked}
        typeData={typeData}
      />
    </>
  );
};
